module.exports = __webpack_public_path__ + "img/red-packet-bg.fbd01af2.png";